<div class="main-container background">
  <div class="title-section">
    <p class="font-18 text-heading-color margin-custom font-weight-600">
      Subscriber Contact Information
    </p>
    <p class="font-14 sub-heading-color font-weight-200">
      Your Contact information is used for billing and purchase a subscription.
    </p>
  </div>
  <div class="webview box">
    <form [formGroup]="editContactInfo">
      <div class="row">
        <p class="font-12 text-color font-weight-400">*Required field</p>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">First Name</label>
            <input type="text" class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              placeholder="Enter First Name" formControlName="first_name" [ngClass]="
                ((editContactInfo.get('first_name').touched ||
                  editContactInfo.get('first_name').dirty) &&
                editContactInfo.get('first_name').hasError('required') ||
                editContactInfo.get('first_name').hasError('firstNotAlpha')
                  ? 'is-invalid'
                  : '') ||
                    (((editContactInfo.get('first_name').touched ||
                      editContactInfo.get('first_name').dirty) &&
                      !editContactInfo.get('first_name').invalid)
                  ? 'is-valid'
                  : '')
              " />
            <div class="invalid-feedback">
              {{
              editContactInfo.get("first_name").hasError("required")
              ? "First Name is required"
              : ""
              }}
              {{
              editContactInfo.get("first_name").hasError("firstNotAlpha")
              ? "Enter valid First Name"
              : ""
              }}
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Last Name</label>
            <input type="text" placeholder="Enter Last Name"
              class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              formControlName="last_name" [ngClass]="
                ((editContactInfo.get('last_name').touched ||
                  editContactInfo.get('last_name').dirty) &&
                editContactInfo.get('last_name').hasError('required') ||
                editContactInfo.get('last_name').hasError('lastNotAlpha')
                  ? 'is-invalid'
                  : '') ||
                    (((editContactInfo.get('last_name').touched ||
                      editContactInfo.get('last_name').dirty) &&
                      !editContactInfo.get('last_name').invalid)
                  ? 'is-valid'
                  : '')
              " />
            <div class="invalid-feedback">
              {{
              editContactInfo.get("last_name").hasError("required")
              ? "Last Name is required"
              : ""
              }}
              {{
              editContactInfo.get("last_name").hasError("lastNotAlpha")
              ? "Enter valid Last Name"
              : ""
              }}
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Primary Phone Number</label>
            <input type="text" class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              placeholder="Enter Primary Phone Number" formControlName="phone" appMaskPhone maxlength="14" [ngClass]="
                ((editContactInfo.get('phone').touched ||
                  editContactInfo.get('phone').dirty) &&
                editContactInfo.get('phone').hasError('required') ||
                editContactInfo.get('phone').hasError('notMinLength')
                  ? 'is-invalid'
                  : '') ||
                    (((editContactInfo.get('phone').touched ||
                      editContactInfo.get('phone').dirty) &&
                      !editContactInfo.get('phone').invalid)
                  ? 'is-valid'
                  : '')
              " />
            <div class="invalid-feedback">
              {{
              editContactInfo.get("phone").hasError("required")
              ? "Phone number is required"
              : ""
              }}
              {{
              editContactInfo.get("phone").hasError("primaryNotValid")
              ? "Special characters are not allowed in phone number"
              : ""
              }}
              {{
              editContactInfo.get('phone').hasError("notMinLength")
              ? "Phone number should be atleast 10 digits"
              : ""
              }}
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Primary Phone Number Type</label>
            <select class="form-select input-styles {{ isAcura ? 'AcuraDropdown' : 'HondaDropdown'}}"
              formControlName="mobile_prov">
              <option *ngFor="let type of primaryPhoneTypes; trackBy: trackByNgForItem">
                {{ type.value }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color">Secondary Phone Number</label>
            <input type="text" placeholder="Enter Secondary Phone Number"
              class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              formControlName="cell_phone" appMaskPhone maxlength="14" [ngClass]="
              ((editContactInfo.get('cell_phone').touched
              || editContactInfo.get('cell_phone').dirty)
              && editContactInfo.get('cell_phone').hasError('notSecMinLength')
              ? 'is-invalid' : '')  ||
              (((editContactInfo.get('cell_phone').touched &&
              editContactInfo.get('cell_phone').dirty) &&
              !editContactInfo.get('cell_phone').invalid) ? 'is-valid' : '')" />
            <div class="invalid-feedback">
              {{
              editContactInfo.get("cell_phone").hasError("secondaryNotValid")
              ? "Special characters are not allowed in phone no"
              : ""
              }}
              {{
              editContactInfo.get('cell_phone').hasError("notSecMinLength")
              ? "Phone number should be atleast 10 digits"
              : ""
              }}
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Primary Phone Number Type</label>
            <select class="form-select input-styles {{ isAcura ? 'AcuraDropdown' : 'HondaDropdown'}}"
              formControlName="mobile_prov">
              <option *ngFor="let type of secondaryPhoneTypes; trackBy: trackByNgForItem">
                {{ type.value }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Country</label>
            <select class="form-select input-styles {{ isAcura ? 'AcuraDropdown' : 'HondaDropdown'}}"
              formControlName="country_cd" (change)="onCountryChange($event)">
              <option *ngFor="let contoury of countries; trackBy: trackByNgForItem" [value]="contoury.value">
                {{ contoury.displayValue }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Email</label>
            <input type="text" placeholder="Enter Email"
              class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              formControlName="email" [ngClass]="
                ((editContactInfo.get('email').touched ||
                  editContactInfo.get('email').dirty) &&
                editContactInfo.get('email').hasError('required')
                   || editContactInfo.get('email').hasError('email')
                  ? 'is-invalid'
                  : '') ||
                    (((editContactInfo.get('email').touched ||
                      editContactInfo.get('email').dirty) &&
                      !editContactInfo.get('email').invalid)
                  ? 'is-valid'
                  : '')
              " required />
            <div class="invalid-feedback">
              {{
              editContactInfo.get("email").hasError("email")
              ? "Enter Valid Email"
              : ""
              }}
              {{
              editContactInfo.get("email").hasError("required")
              ? "Email is Required"
              : ""
              }}
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color">Business Name</label>
            <input type="text" class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              placeholder="Enter Business Name (Optional)" formControlName="company_name" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Prefered Language</label>
            <select class="form-select input-styles {{ isAcura ? 'AcuraDropdown' : 'HondaDropdown'}}"
              formControlName="locale_name">
              <option *ngFor="let lan of preferredLanguage; trackBy: trackByNgForItem" [value]="lan.value">
                {{ lan.displayValue }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Address Line 1</label>

            <input type="text" class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              placeholder="Enter Address Line 1" formControlName="address1" [ngClass]="
        (
          (editContactInfo.get('address1').touched ||
           editContactInfo.get('address1').dirty) &&
          (
            editContactInfo.get('address1').hasError('required') ||
            editContactInfo.get('address1').hasError('addressOnlySpace') ||
            editContactInfo.get('address1').hasError('invalidAddress')
          )
        )
          ? 'is-invalid'
          : (
              (editContactInfo.get('address1').touched ||
               editContactInfo.get('address1').dirty) &&
              !editContactInfo.get('address1').invalid
            )
          ? 'is-valid'
          : ''
      " />

            <div class="invalid-feedback">
              {{
              editContactInfo.get('address1').hasError('required')
              ? 'Address is Required'
              : ''
              }}

              {{
              editContactInfo.get('address1').hasError('addressOnlySpace') ||
              editContactInfo.get('address1').hasError('invalidAddress')
              ? 'Enter a valid address'
              : ''
              }}
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color">Address Line 2</label>

            <input type="text" placeholder="Apartment, Suite Unit, Building, Floor (Optional)"
              class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              formControlName="address2" [ngClass]="
        (
          editContactInfo.get('address2').value &&
          (editContactInfo.get('address2').touched ||
           editContactInfo.get('address2').dirty) &&
          (
            editContactInfo.get('address2').hasError('addressOnlySpace') ||
            editContactInfo.get('address2').hasError('invalidAddress')
          )
        )
          ? 'is-invalid'
          : (
              editContactInfo.get('address2').value &&
              (editContactInfo.get('address2').touched ||
               editContactInfo.get('address2').dirty) &&
              !editContactInfo.get('address2').invalid
            )
          ? 'is-valid'
          : ''
      " />

            <div class="invalid-feedback">
              {{
              editContactInfo.get('address2').hasError('addressOnlySpace') ||
              editContactInfo.get('address2').hasError('invalidAddress')
              ? 'Enter a valid address'
              : ''
              }}
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">City</label>

            <input type="text" class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              placeholder="Enter City" formControlName="city" [ngClass]="
        (
          (editContactInfo.get('city').touched ||
           editContactInfo.get('city').dirty) &&
          (
            editContactInfo.get('city').hasError('required') ||
            editContactInfo.get('city').hasError('cityOnlySpace') ||
            editContactInfo.get('city').hasError('invalidCity')
          )
        )
          ? 'is-invalid'
          : (
              (editContactInfo.get('city').touched ||
               editContactInfo.get('city').dirty) &&
              !editContactInfo.get('city').invalid
            )
          ? 'is-valid'
          : ''
      " />

            <div class="invalid-feedback">
              {{
              editContactInfo.get('city').hasError('required')
              ? 'City is Required'
              : ''
              }}

              {{
              editContactInfo.get('city').hasError('cityOnlySpace') ||
              editContactInfo.get('city').hasError('invalidCity')
              ? 'Enter a valid city name'
              : ''
              }}
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color">State / Province</label>
            <select class="form-select input-styles {{ isAcura ? 'AcuraDropdown' : 'HondaDropdown'}}"
              formControlName="state_prov">
              <option disabled selected [value]="null" style="display:none">Select State</option>
              <option *ngFor="let state of stateProvDropdown; trackBy: trackByNgForItem" [value]="state.value">
                {{ state.displayValue }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-group text-color required">Zip Code</label>
            <input type="text" class="form-control input-styles {{isAcura ? 'AcuraPlaceholder' : 'HondaPlaceholder'}}"
              placeholder="Enter Zip" formControlName="postal_cd" [ngClass]="
                ((editContactInfo.get('postal_cd').touched ||
                  editContactInfo.get('postal_cd').dirty) &&
                editContactInfo.get('postal_cd').hasError('required') ||
                editContactInfo.get('postal_cd').hasError('zipUSNotValid') ||
                editContactInfo.get('postal_cd').hasError('zipCADNotValid')
                  ? 'is-invalid'
                  : '') ||
                    (((editContactInfo.get('postal_cd').touched ||
                      editContactInfo.get('postal_cd').dirty) &&
                      !editContactInfo.get('postal_cd').invalid)
                  ? 'is-valid'
                  : '')
              " />
            <div class="invalid-feedback">
              {{
              editContactInfo.get("postal_cd").hasError("required")
              ? "ZipCode is Required"
              : ""
              }}
              {{
              editContactInfo.get("postal_cd").hasError("zipUSNotValid")
              ? "Enter a valid zip code (XXXXX or XXXXX-XXXX)"
              : ""
              }}
              {{
              editContactInfo.get("postal_cd").hasError("zipCADNotValid")
              ? "Enter a valid zip code (A1A1X1)"
              : ""
              }}
            </div>
          </div>
        </div>

        <div class="private-policy">
          <p class="font-14 private-policy-wv">
            To learn more about how we collect and use personal information, please
            read our <a href="https://www.honda.com/privacy/privacy-notice"
              target="{{isWebView ? '_self' : '_blank'}}">Privacy Notice</a>.
          </p>
        </div>
      </div>
    </form>
  </div>
  <div class="background action-btn-container flex-column justify-content-center align-items-center">
    <button mat-flat-button
      class="edit-form-button button-right-no-radius standard-btn {{isAcura ? 'AcuraBtn-disabled' : 'HondaBtn-disabled'}}"
      [disabled]="editContactInfo.invalid" (click)="onSaveClick()">
      Save
    </button>
    <button mat-flat-button class="edit-form-button standard-btn button-previous" (click)="onBackClick()">
      Previous
    </button>
  </div>
</div>